var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPbCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pb-copy_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 996",
    transform: "translate(1592 100)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h32v32H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1592 -100)",
    clipPath: "url(#pb-copy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Compound Path",
    d: "M1617.085 106.915h-13.543v13.543h13.543zm-1.454 12.089h-10.635v-10.635h10.635z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1602.331 112.996v-1.454h-3.416v13.543h13.543v-3.392h-1.454v1.938h-10.635v-10.635z"
  }))));
}

export default __webpack_public_path__ + "f5347f4b574430d134881da475e8e962.svg";
export { SvgPbCopy as ReactComponent };